"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as i } from "react";
import r from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.8 4.5H4.5v6.307h6.3zm8.7 0h-6.3v6.307h6.3zm-15 8.693h6.3V19.5H4.5zm15 0h-6.3V19.5h6.3z",
        clipRule: "evenodd"
      }
    )
  }
), d = i(l);
export {
  d as GridView,
  d as default
};
